var acContact = acContact || {};

if (!Object.create) {
    Object.create = (function() {
        function F() {}

        return function(o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function($) {

    $.fn.contactForm = function(options) {
        return this.each(function() {
            var contactForm = Object.create(acContact.contactForm);
            contactForm.init(this, options);
        });
    };

    $.fn.contactForm.options = {};

    acContact.contactForm = {

        init(elem, options) {
            var self = this;
            self.$container = $(elem);
            self.options = $.extend({}, $.fn.showHide.options, options);

            self.$inputs = self.$container.find(":input");
            self.$textarea = self.$container.find("textarea");

            self.$successMessage = self.$container.find(".contact-form__success");

            self.$noError = true;

            self.bindElements();
        },

        bindElements() {
            var self = this;

            self.$inputs.on("focus", function() {
                if ($(this).parent().hasClass("has-error")) {
                    self.$noError = false;
                    self.hideError($(this));
                }
            });

            self.$textarea.on("focus", function() {
                if ($(this).parent().hasClass("has-error")) {
                    self.$noError = false;
                    self.hideError($(this));
                }
            });

            self.$container.on("submit", function(e) {

                self.buildArray(e);
                return false;
            });
        },

        buildArray(targets) {
            var self = this;

            var validate = self.$container.serializeArray();

            self.$noError = true;

            $(validate).each(function(i, v) {
                switch (v.name) {
                    case 'category':
                        break;

                    case "firstName":
                        self._validateGeneralRules(v) && self._validateRequired(v);
                        break;

                    case "lastName":
                        self._validateGeneralRules(v) && self._validateRequired(v);
                        break;

                    case "Street1":
                        self._validateGeneralRules(v);
                        break;

                    case "street2":
                        self._validateGeneralRules(v);
                        break;

                    case "city":
                        self._validateGeneralRules(v);
                        break;

                    case "stateProvince":
                        self._validateGeneralRules(v) && self._validateProvince(v);
                        break;

                    case "country":
                        self._validateGeneralRules(v);
                        break;

                    case "zip":
                        self._validateGeneralRules(v);
                        break;

                    case "email":
                        self._validateGeneralRules(v) && self._validateRequired(v) && self._validateEmail(v);
                        break;

                    case "thoughts":
                        self._validateGeneralRules(v) && self._validateRequired(v);
                        break;

                    case "secureQuestion":
                        self._validateSecurity(v);
                        break;
                }
            });

            if (self.$noError) {
                self._sendForm();
            }
        },
        _validateGeneralRules(input) {

            var self = this;
            var regex1 = /(https)|(http)|(www)/ig;
            var regex2 = /[\~$%^*\[\]}{><=|]/g;

            if (regex1.test(input.value)) {
                self._throwError(input, 'data-error-www');
                return false;
            }

            if (regex2.test(input.value)) {
                self._throwError(input, 'data-error-specialChars');
                return false;
            }

            return true;
        },

        _validateRequired(input){
            var self = this;
            if (input.value.trim() === "") {
                self._throwError(input,'data-error-required');
                return false;
            }
            return true;
        },

        _validateNames(input) {
            var self = this;
            if (input.value.trim() === "") {
                self._throwError(input)
            }
        },

        _validateStreet(input) {
            var self = this;

            if (input.value.length < 5) {
                self._throwError(input);
            }
        },

        _validateProvince(input){
            var self = this;

            if(input.value.length > 3){
                self._throwError(input, 'data-error-valid');
            }
        },

        _validateEmail(input) {
            var self = this;
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            var emailTest = re.test(input.value);

            !emailTest && self._throwError(input, 'data-error-valid');

        },

        _validateThoughts(textarea){
            var self = this;
            if(textarea.value.trim() === ""){
                self._throwError(textarea);
            }
        },

        _validateSecurity(input) {
            var self = this;

            if (input.value.length) {
                self.$noError = false;
                self.showMessage("Sorry, Error has Occured", "show-error")
            }
        },

        hideError(input) {
            var self = this;

            $(input).parent().removeClass("has-error");

            setTimeout(function() {
                $(input).parent().find(".contact-form__error").remove();
            }, 300);
        },

        _throwError(input, dataError) {
            var self = this,
                inputElem = $("[name=" + input.name + "]"),
                message,
                errorMessage;

            self.$noError = false;

            if(dataError){
                message = inputElem.attr(dataError);

            }
            else{
                message = inputElem.data("error");
            }

            errorMessage = "<p class='contact-form__error'>" + message + "</p>";

            if (inputElem.parent().hasClass("has-error")) {
                inputElem.parent().find(".contact-form__error").text(message);
            } else {
                inputElem.parent().addClass("has-error").append(errorMessage);
            }
        },

        _sendForm() {
            var self = this;

            self.$container.find(":button").prop("disabled", true);

            var inprogressMessage = "Your request is being processed.";
            var recapthaFailMessage = "The recaptcha code is invalid. Please try again...";
            var errorMessage = "Sorry, an error has occured. Please try again later";

            self.showMessage(inprogressMessage, "show-success");

            $.ajax({
                type: "GET",
                url: self.$container.attr("action"),
                data: self.$container.serialize(),
                dataType: "json",
            })
            .done(function(response) {
                if (response.status) {
                    self.showMessage(response.successMessage, "show-success");
                } else {
                    self.showMessage(recapthaFailMessage, "show-error");
                    //self.showMessage(response.failMessage, "show-error");
                    //self._ajaxError(response.fields);
                }
            })
            .fail(function(e) {
                self.showMessage(errorMessage, "show-error");
            })
            .always(function() {
                self.$container.find(":button").prop("disabled", false);

                // reset contact us form
                self.$container.trigger("reset");
                if (typeof grecaptcha != "undefined" && grecaptcha != null)
                    grecaptcha.reset();

                setTimeout(function(){
                    self.$successMessage.removeClass("show-error show-success", function() {
                        self.$successMessage.empty()
                    });
                }, 5000);
            });
        },

        showMessage(message, cssClass) {
            var self = this;
            self.$successMessage.text(message).addClass(cssClass);
        },

        _ajaxError(inputs) {
            var self = this;
            $(inputs).each(function(i, v) {
                if (!v.valid) {
                    self._ajaxThrowError(v);
                }
            });
        },

        _ajaxThrowError(input) {
            var self = this;
            var message = input.errorMessage;
            var errorMessage = "<p class='contact-form__error'>" + message + "</p>";

            self.$noError = false;

            if ($("[name=" + input.fieldName + "]").parent().hasClass("has-error")) {
                $("[name=" + input.fieldName + "]").parent().find(".contact-form__error").text(message);
            } else {
                $("[name=" + input.fieldName + "]").parent().addClass("has-error").append(errorMessage);

            }

        }
    }
});
